"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MailAccordion = void 0;
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GRID_SPACING = 1;

/**
 * 個人情報設定 その他メールアドレス
 */
class MailAccordion extends _react.default.Component {
  render() {
    const {
      setEntry,
      intl,
      entries,
      mailAddress2Error,
      mailAddress3Error
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Accordion.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_MAIL_ADDRESS
      }),
      help: /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.USERCUSTOM_MAIL_ADDRESS_HELP
      })
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: GRID_SPACING
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_MAIL_ADDRESS_1
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.mailAddress1)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_MAIL_ADDRESS_2
      })
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: entries.mailAddress2,
      onChange: setEntry('mailAddress2'),
      maxLength: 100,
      error: !!mailAddress2Error,
      helperText: mailAddress2Error
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_MAIL_ADDRESS_3
      })
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: entries.mailAddress3,
      onChange: setEntry('mailAddress3'),
      maxLength: 100,
      error: !!mailAddress3Error,
      helperText: mailAddress3Error
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_UPDATE_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.mailUpdDt))))));
  }
}
exports.MailAccordion = MailAccordion;
MailAccordion.propTypes = {
  setEntry: _propTypes.default.func,
  intl: _propTypes.default.object,
  entries: _propTypes.default.object,
  mailAddress2Error: _propTypes.default.string,
  mailAddress3Error: _propTypes.default.string
};
const mapStateToProps = state => {
  return {
    entries: state.personalRegister.entries
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)((0, _CodeUtil.withCodeUtil)(MailAccordion));